var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProcessing)?_c('div',{staticClass:"mail"},_vm._l((_vm.items),function(item){return _c('mail-menu',{key:item.title,staticClass:"user__menu",attrs:{"item":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }